import { evaluate } from '../dsl/evaluator'
import { moneyFlowProgram } from '../dsl/programs'

export default {
  key: 'moneyFlow',
  title: 'Dòng tiền',

  xLabel: 'Thay đổi',
  yLabel: 'Dòng tiền',
  xUnit: '%',
  xRange: [-16, 16],
  yRange: [0, 5],
  xStep: 2,
  yStep: 1,

  xHighlights: [0],
  yHighlights: [1],

  zones: [
    {
      from: 0, to: 1, color: '#FF4C5166', label: 'Tiền chưa vào (0-1)', labelColor: '#FF4C51',
    },
    {
      from: 1, to: 2, color: '#FFB40055', label: 'Tiền vào tốt (1-2)', labelColor: '#B27D00',
    },
    {
      from: 2, to: 3, color: '#56CA0055', label: 'Tiền vào siêu sóng (2-3)', labelColor: '#3F9000',
    },
    {
      from: 3, to: 4, color: '#56CA00AA', label: 'Tiền cực đại (3-4)', labelColor: '#2D6700',
    },
    {
      from: 4, to: 5, color: '#fff', label: 'Cảnh báo hưng phấn', labelColor: '#3A3541',
    },
  ],

  compute(raw) {
    const {
      o = [], h = [], l = [], c = [], v = [], t = [],
    } = raw || {}
    if (!t.length) return { t: [], x: [], y: [] }

    const result = evaluate(moneyFlowProgram, {
      open: o, high: h, low: l, close: c, volume: v,
    })

    const x = new Array(c.length)
    x[0] = 0
    for (let i = 1; i < c.length; i += 1) {
      const prev = c[i - 1]
      x[i] = prev ? ((c[i] / prev) - 1) * 100 : 0
    }

    return { t, x, y: result.nbf }
  },
}
